angular
  .module('quote')

  .factory('QuoteCountersCache', function() {
    let cache;

    return {
      get: () => cache,
      set: value => (cache = value)
    };
  });
